export enum ValidationErrorType {
  DUPLICATE = "duplicate",
  INVALID_FORMAT = "invalid-format",
  REQUIRED = "required",
  NOT_FOUND = "not-found",
  UNKNOWN = "unknown",
  TOKEN_MISMATCH = "token-mismatch",
  UNAUTHORIZED = "unauthorized"
}
